import React from 'react';
import { MlTipNotificationDto } from '@src/dtos/notification.dto';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { EventType } from '@src/dtos/analytics.dto';

interface MlTipNotificationProps {
    notification: MlTipNotificationDto;
    serviceName?: string;
}

const MlTipNotification: React.FC<MlTipNotificationProps> = observer(({ notification, serviceName }) => {
    const { fwVersionStore, notificationStore } = useStores();

    const showMlRecommendationModal = () => {
        fwVersionStore.sendGeneralEvent(EventType.LinkClicked,
            { button: 'viewMlRecommendation', location: 'notification' });

        notificationStore.setNotificationVisible(false);

        fwVersionStore.setMlRecommendationData({
            applicationsToBlock: notification.applicationsToBlock ?? [],
            ipsToBlock: notification.ipsToBlock ?? [],
            serviceId: notification.serviceId,
            recommendationWasApplied: notification.applied,
            connectionName: serviceName
        });
    };

    return <div className="details">
        {`AI generated a new policy update recommendations for V${notification.policyVersionNumber} to enhance your business protection.`}
        <button type="button" className="link" onClick={showMlRecommendationModal}>View recommendation</button>
    </div>;
});

export default MlTipNotification;
